import { type FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Draggable } from 'react-beautiful-dnd';
import { BsFileEarmarkPlus, BsTrash } from 'react-icons/bs';

import { deletePageFromPageGroup } from '@editor2/reducers/editor/editorSlice';
import { type RootState } from '@editor2/reducers/root';
import AddPageModal from '@editor2/components/AddPageModal';
import { pageContainer, headerContainer } from '@editor2/containers/PageGroupPage/styles';
import { getPageNumberIfExistsAndNotSpace } from '@editor2/services/pagesService';

interface Props {
	pageId: string;
	pageGroupId: string;
	chapterId: string;
	index: number;
	courseId: number;
}

const Page: FC<Props> = (props) => {
	const { pageId, pageGroupId, chapterId, index, courseId } = props;

	const dispatch = useDispatch();
	const { pages, course } = useSelector((state: RootState) => state.courses[courseId]);
	const page = pages.entities[pageId];

	const [isAddPageModalShown, setAddPageModalShown] = useState(false);

	const onDeletePageClick = (pageId: string) => {
		// eslint-disable-next-line no-alert
		if (window.confirm(`Are you sure to delete "${page.name}" page group?`)) {
			dispatch(deletePageFromPageGroup({ pageGroupId, pageId, courseId }));
		}
	};

	return (
		<Draggable draggableId={pageId} index={index}>
			{(provided) => (
				<div
					className={pageContainer}
					ref={provided.innerRef}
					{...provided.draggableProps}
					{...provided.dragHandleProps}>
					<div className={headerContainer}>
						<div className="menu">
							<BsFileEarmarkPlus onClick={() => setAddPageModalShown(true)} />
							<BsTrash onClick={() => onDeletePageClick(pageId)} />
						</div>

						<div className="headerText">
							<div>
								<span>Page{getPageNumberIfExistsAndNotSpace(pages.entities[pageId])}: </span>
								<Link
									to={`/courses/${course.id}/chapters/${chapterId}/page_groups/${pageGroupId}/pages/${pageId}`}>
									{page.name}
								</Link>
							</div>
						</div>
					</div>

					{isAddPageModalShown && (
						<AddPageModal
							pageGroupId={pageGroupId}
							index={index + 1}
							onHide={() => setAddPageModalShown(false)}
							isShown={isAddPageModalShown}
							courseId={courseId}
						/>
					)}
				</div>
			)}
		</Draggable>
	);
};

export default Page;
